import Eyebrow from "@/components/Eyebrow";
import { usePageMeta, COMPANY } from "@/lib/site";

export default function Privacy() {
  usePageMeta(
    "Zásady zpracování OÚ — G&G accounting",
    "Informace o zpracování osobních údajů podle GDPR na webu G&G accounting."
  );
  return (
    <article className="px-6 md:px-12 py-20 md:py-28 bg-white">
      <div className="max-w-3xl mx-auto">
        <Eyebrow>GDPR</Eyebrow>
        <h1 className="font-display text-4xl md:text-6xl tracking-tighter font-medium mt-6 leading-[1.05]">
          Zásady zpracování osobních údajů
        </h1>
        <div className="mt-10 space-y-6 text-base md:text-lg text-muted2 leading-relaxed">
          <p>
            Tento dokument informuje o tom, jakým způsobem zpracováváme osobní údaje na webu
            <span className="text-ink font-medium"> brno-ucetnictvi.cz</span>. Zpracování probíhá v souladu
            s nařízením (EU) 2016/679 (GDPR) a zákonem č. 110/2019 Sb.
          </p>

          <h2 className="font-display text-2xl text-ink font-medium tracking-tight pt-4">1. Správce osobních údajů</h2>
          <p>
            Správcem je <strong className="text-ink">{COMPANY.name}</strong>, IČO {COMPANY.ico}, se sídlem {COMPANY.address}.
            Kontaktní e-mail: <a href={`mailto:${COMPANY.emailBystricka}`} className="text-magenta hover:underline">{COMPANY.emailBystricka}</a>.
          </p>

          <h2 className="font-display text-2xl text-ink font-medium tracking-tight pt-4">2. Rozsah zpracování</h2>
          <p>
            Zpracováváme údaje, které nám sami poskytnete prostřednictvím kontaktního formuláře nebo
            kalkulačky ceny — tj. zejména jméno a příjmení, e-mail, telefon, název firmy a obsah zprávy.
          </p>

          <h2 className="font-display text-2xl text-ink font-medium tracking-tight pt-4">3. Účel a právní základ</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Vyřízení vaší poptávky / dotazu — právní základ: souhlas a oprávněný zájem.</li>
            <li>Zaslání nezávazné nabídky a navazující komunikace — právní základ: souhlas.</li>
          </ul>

          <h2 className="font-display text-2xl text-ink font-medium tracking-tight pt-4">4. Doba uchování</h2>
          <p>
            Údaje uchováváme po dobu nezbytně nutnou — typicky po dobu vyřízení dotazu a následně
            po dobu 12 měsíců, pokud neodvoláte souhlas dříve.
          </p>

          <h2 className="font-display text-2xl text-ink font-medium tracking-tight pt-4">5. Příjemci údajů</h2>
          <p>
            Údaje předáváme pouze prověřeným zpracovatelům (poskytovatel hostingu, e-mailová služba
            pro doručení zprávy) v rámci EU.
          </p>

          <h2 className="font-display text-2xl text-ink font-medium tracking-tight pt-4">6. Vaše práva</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>právo na přístup ke svým údajům;</li>
            <li>právo na opravu nebo výmaz;</li>
            <li>právo na omezení zpracování;</li>
            <li>právo na přenositelnost;</li>
            <li>právo vznést námitku či odvolat souhlas;</li>
            <li>právo podat stížnost u Úřadu pro ochranu osobních údajů (uoou.cz).</li>
          </ul>

        </div>
      </div>
    </article>
  );
}
